(function(app) {

    app.provider("financeApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(financeId) {
                            return crmApiGateway.get("/Finances/" + financeId);
                        };

                        service.getClientFinance = function(clientId) {
                            return crmApiGateway.get("/People/" + clientId + "/Finances");
                        };

                        service.getOtherFinances = function(financeId) {
                            return crmApiGateway.getArray("/Finances/" + financeId + "/OtherFinances");
                        };

                        service.getOtherFinance = function(financeId, otherFinanceId) {
                            return crmApiGateway.get("/Finances/" + financeId + "/OtherFinances/" + otherFinanceId);
                        };

                        service.update = function(financeId, finance) {
                            return crmApiGateway.put("/Finances/" + financeId, finance);
                        };

                        service.updateAssets = function(financeId, finance) {
                            return crmApiGateway.put("/Finances/" + financeId + "/Assets", finance);
                        };

                        service.updateLiabilities = function (financeId, finance) {
                            return crmApiGateway.put("/Finances/" + financeId + "/Liabilities", finance);
                        };

                        service.updateMonthlyIncomes = function (financeId, finance) {
                            return crmApiGateway.put("/Finances/" + financeId + "/MonthlyIncomes", finance);
                        };

                        service.updateMonthlyExpenses = function (financeId, finance) {
                            return crmApiGateway.put("/Finances/" + financeId + "/MonthlyExpenses", finance);
                        };

                        service.updateOtherFinance = function(financeId, otherFinanceId, otherFinance) {
                            return crmApiGateway.put("/Finances/" + financeId + "/OtherFinances/" + otherFinanceId, otherFinance);
                        };

                        service.create = function(clientId, finance) {
                            return crmApiGateway.post("People/" + clientId + "/Finances", finance);
                        };

                        service.addOtherFinance = function(financeId, otherFinance) {
                            return crmApiGateway.post("/Finances/" + financeId + "/OtherFinances", otherFinance);
                        };

                        service.removeOtherFinance = function(financeId, otherFinanceId) {
                            return crmApiGateway.delete("/Finances/" + financeId + "/OtherFinances/" + otherFinanceId);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line